export default __webpack_public_path__ + "c7ca6ebe84d602c4ac83fb900a5bb1cc.png";